import { useEffect, useState } from "react";
import { todayLocalISO } from "@workspace/shared";

/** Today ("2026-10-01"), turning over at midnight while the page stays open. */
export function useToday(): string {
  const [today, setToday] = useState(todayLocalISO);
  useEffect(() => {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const timer = setTimeout(() => setToday(todayLocalISO()), midnight.getTime() - now.getTime() + 1000);
    return () => clearTimeout(timer);
  }, [today]);
  return today;
}
